module.exports = __webpack_public_path__ + "img/floorplan-pitchview.9c8fb379.png";